import {CLOSE_SNACKBAR, OPEN_SNACKBAR} from 'shared/constants/ActionTypes';

export const openSnackbar = (payload) => {
  return (dispatch) => dispatch({type: OPEN_SNACKBAR, payload: payload});
};

export const closeSnackbar = () => {
  return (dispatch) => dispatch({type: CLOSE_SNACKBAR});
};
